import React, { useState } from 'react'
import { Button, Typography } from '@material-ui/core'
import moment from 'moment'
import { EllipseStatus, FileViewerDialog } from 'shared'
import { SALE_ORDER_PAYMENT_STATES, STRING_EMPTY } from 'utils/constants'

import { useStyles } from './ReceiptBlock.style'

const showState = (payment) => {
  switch (payment.state) {
    case SALE_ORDER_PAYMENT_STATES.PENDING:
      return 'Pendiente de revisión'
    case SALE_ORDER_PAYMENT_STATES.APPROVED:
      return 'Pago Aprobado'
    case SALE_ORDER_PAYMENT_STATES.CANCELLED:
      return 'Pago Rechazado'
    case SALE_ORDER_PAYMENT_STATES.EXPIRED:
      return 'Pago Vencido'
    default:
      return STRING_EMPTY
  }
}

const observerOptions = {
  [SALE_ORDER_PAYMENT_STATES.PENDING]: {
    value: <EllipseStatus status='yellow' title='Pendiente' />,
    label: 'Pendiente'
  },
  [SALE_ORDER_PAYMENT_STATES.APPROVED]: {
    value: <EllipseStatus status='green' title='Aprobado' />,
    label: 'Aprobado',
    key: 'Approved'
  },
  [SALE_ORDER_PAYMENT_STATES.CANCELLED]: {
    value: <EllipseStatus status='red' title='Anulado' />,
    label: 'Anulado'
  },
  [SALE_ORDER_PAYMENT_STATES.EXPIRED]: {
    value: <EllipseStatus status='grey' title='Vencido' />,
    label: 'Vencido'
  }
}

const ReceiptBlock = ({ installment }) => {
  const classes = useStyles()

  const [openFileViewerDialog, setOpenFileViewerDialog] = useState(false)

  return (
    <div className={classes.block}>
      <Typography color='primary' variant='h6' className={classes.title}>
        Cuota N° {installment?.number}
      </Typography>

      {installment.payments.map((payment) => (
        <div key={payment.id} className={classes.payment}>
          <Typography>Monto pagado: ${payment.amount}</Typography>
          <Typography>
            Fecha que se subio el comprobante:&nbsp;
            {moment(payment.receiptUploadAt).format('DD/MM/YYYY')}
          </Typography>
          <div className={classes.state}>
            Estado:{observerOptions[payment.state].value}
            {showState(payment)}
          </div>
          <Button
            variant='contained'
            color='primary'
            className={classes.receiptButton}
            disabled={!payment.receiptFileUrl}
            onClick={() => setOpenFileViewerDialog(true)}>
            Ver comprobante
          </Button>
          <FileViewerDialog
            title={payment.receiptFile?.fileName}
            fileUrl={payment.receiptFileUrl}
            fileExtension={payment.receiptFile?.contentType?.split('/')[1]}
            open={openFileViewerDialog}
            onClose={() => setOpenFileViewerDialog(false)}
          />
        </div>
      ))}
    </div>
  )
}

export default ReceiptBlock
